function writeSceneLog(logger, message, ...rest) {
  if (window.grafanaSceneLogging) {
    console.log(`${logger}: `, message, ...rest);
  }
}

export { writeSceneLog };
//# sourceMappingURL=writeSceneLog.js.map
